// extracted by mini-css-extract-plugin
export default {"zoomModal":"S5-z"};